module.exports = __webpack_public_path__ + "img/9788996995975.8b092160.jpg";